import { render, staticRenderFns } from "./MvpForm.vue?vue&type=template&id=b7151280&scoped=true&"
import script from "./MvpForm.vue?vue&type=script&lang=js&"
export * from "./MvpForm.vue?vue&type=script&lang=js&"
import style0 from "./MvpForm.vue?vue&type=style&index=0&id=b7151280&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7151280",
  null
  
)

export default component.exports